import { createReducer, on } from '@ngrx/store';
import {
  HubspotNewCompany,
  HubspotNewCompanyFailure,
  HubspotNewCompanySuccess,
  HubspotNewContact,
  HubspotNewContactFailure,
  HubspotNewContactSuccess,
  getHubspotCompanies,
  getHubspotCompaniesFailure,
  getHubspotCompaniesSuccess,
  getHubspotCompany,
  getHubspotCompanyFailure,
  getHubspotCompanyIndustries,
  getHubspotCompanyIndustriesFailure,
  getHubspotCompanyIndustriesSuccess,
  getHubspotCompanyLifeCycleStages,
  getHubspotCompanyLifeCycleStagesFailure,
  getHubspotCompanyLifeCycleStagesSuccess,
  getHubspotCompanySuccess,
  getHubspotContact,
  getHubspotContactFailure,
  getHubspotContactSuccess,
  getHubspotDealOwners,
  getHubspotDealOwnersFailure,
  getHubspotDealOwnersSuccess,
  getHubspotDealPipelines,
  getHubspotDealPipelinesFailure,
  getHubspotDealPipelinesSuccess,
  getHubspotDealStages,
  getHubspotDealStagesFailure,
  getHubspotDealStagesSuccess,
  getHubspotDeals,
  getHubspotDealsFailure,
  getHubspotDealsSuccess,
  hubspotNewDeal,
  hubspotNewDealFailure,
  hubspotNewDealSuccess,
  showMoreHubspotDeals,
  showMoreHubspotDealsFailure,
  showMoreHubspotDealsSuccess,
} from './hubspot.actions';
import { clearHubspot } from '../search/search.actions';

export interface HubspotState {
  hubspot_deals: any;
  hubspot_contact: any;
  hubspot_company: any;
  hubspot_quotes: any;
  hubspot_new_contact: any;
  hubspot_new_company: any;
  hubspot_companies: any;
  hubspot_company_life_cycle_stages: any;
  hubspot_company_industries: any;
  hubspot_refreshed: any;
  hubspot_deal_pipelines: any;
  hubspot_deal_stages: any;
  hs_object: any;
  hubspot_deal_owners: any;
  loadingHubspot: any;
  error: any;
}

const initialState: HubspotState = {
  hubspot_deals: null,
  hubspot_contact: null,
  hubspot_company: null,
  hubspot_quotes: null,
  hubspot_new_contact: null,
  hubspot_new_company: null,
  hubspot_companies: null,
  hubspot_company_life_cycle_stages: null,
  hubspot_company_industries: null,
  hubspot_refreshed: false,
  hubspot_deal_pipelines: null,
  hubspot_deal_stages: null,
  hs_object: null,
  hubspot_deal_owners: null,
  loadingHubspot: null,
  error: null,
};

export const hubspotReducer = createReducer(
  initialState,
  on(getHubspotContact, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(getHubspotContactSuccess, (state, { hubspot_contact }) => {
    return { ...state, hubspot_contact, loadingHubspot: false, error: null };
  }),
  on(getHubspotContactFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_contact: null };
  }),

  on(getHubspotCompany, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(getHubspotCompanySuccess, (state, { hubspot_company }) => {
    return { ...state, hubspot_company, loadingHubspot: false, error: null };
  }),
  on(getHubspotCompanyFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_company: null };
  }),

  on(getHubspotCompanies, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(getHubspotCompaniesSuccess, (state, { hubspot_companies }) => {
    return { ...state, hubspot_companies, loadingHubspot: false, error: null };
  }),
  on(getHubspotCompaniesFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_companies: null };
  }),

  on(getHubspotCompanyLifeCycleStages, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(
    getHubspotCompanyLifeCycleStagesSuccess,
    (state, { hubspot_company_life_cycle_stages }) => {
      return {
        ...state,
        hubspot_company_life_cycle_stages,
        loadingHubspot: false,
        error: null,
      };
    }
  ),
  on(getHubspotCompanyLifeCycleStagesFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false };
  }),

  on(getHubspotCompanyIndustries, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(
    getHubspotCompanyIndustriesSuccess,
    (state, { hubspot_company_industries }) => {
      return {
        ...state,
        hubspot_company_industries,
        loadingHubspot: false,
        error: null,
      };
    }
  ),
  on(getHubspotCompanyIndustriesFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false };
  }),

  on(getHubspotDealOwners, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(getHubspotDealOwnersSuccess, (state, { hubspot_deal_owners }) => {
    return {
      ...state,
      hubspot_deal_owners,
      loadingHubspot: false,
      error: null,
    };
  }),
  on(getHubspotDealOwnersFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_companies: null };
  }),

  on(getHubspotDealPipelines, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(getHubspotDealPipelinesSuccess, (state, { hubspot_deal_pipelines }) => {
    return {
      ...state,
      hubspot_deal_pipelines,
      loadingHubspot: false,
      error: null,
    };
  }),
  on(getHubspotDealPipelinesFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_companies: null };
  }),

  on(getHubspotDealStages, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(getHubspotDealStagesSuccess, (state, { hubspot_deal_stages }) => {
    return {
      ...state,
      hubspot_deal_stages,
      loadingHubspot: false,
      error: null,
    };
  }),
  on(getHubspotDealStagesFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_companies: null };
  }),

  on(getHubspotDeals, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(getHubspotDealsSuccess, (state, { hubspot_deals }) => {
    return { ...state, hubspot_deals, loadingHubspot: false, error: null };
  }),
  on(getHubspotDealsFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_deals: null };
  }),

  on(showMoreHubspotDeals, (state) => {
    return { ...state, hubspot_deals: null, loadingHubspot: true, error: null };
  }),
  on(showMoreHubspotDealsSuccess, (state, { hubspot_deals }) => {
    return { ...state, hubspot_deals, loadingHubspot: false, error: null };
  }),
  on(showMoreHubspotDealsFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false, hubspot_deals: null };
  }),

  on(HubspotNewContact, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(HubspotNewContactSuccess, (state, { hubspot_new_contact }) => {
    return {
      ...state,
      hubspot_new_contact,
      hubspot_company: null,
      hubspot_contact: null,
      hubspot_deals: null,
      loadingHubspot: false,
      error: null,
    };
  }),
  on(HubspotNewContactFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false };
  }),
  on(HubspotNewCompany, (state) => {
    return { ...state, loadingHubspot: true, error: null };
  }),
  on(HubspotNewCompanySuccess, (state, { hubspot_new_company }) => {
    return {
      ...state,
      hubspot_new_company,
      hubspot_company: null,
      loadingHubspot: false,
      error: null,
    };
  }),
  on(HubspotNewCompanyFailure, (state, { error }) => {
    return { ...state, error, loadingHubspot: false };
  }),
  on(hubspotNewDeal, (state) => {
    return { ...state, hs_object: null, isLoading: true, error: null };
  }),
  on(hubspotNewDealSuccess, (state, { hs_object }) => {
    return { ...state, hs_object, isLoading: false, error: null };
  }),
  on(hubspotNewDealFailure, (state, { error }) => {
    return { ...state, error, isLoading: false };
  }),

  on(clearHubspot, (state) => ({
    ...state,
    hubspot_deals: null,
    hubspot_contact: null,
    hubspot_company: null,
    hubspot_quotes: null,
    hubspot_new_contact: null,
    hubspot_new_company: null,
    hubspot_companies: null,
    hubspot_company_life_cycle_stages: null,
    hubspot_company_industries: null,
    hubspot_refreshed: false,
    hubspot_deal_pipelines: null,
    hubspot_deal_stages: null,
    hs_object: null,
    hubspot_deal_owners: null,
  }))
);
